import {
    getReceiptFromCacheEntry,
    isStructuredReceiptCacheEntry,
} from "pages/v2/echeqMassManagement/echeqMassManageBatchDetailReceiptUtils";
import { getDefaultListFilters } from "pages/v2/echeqMassManagement/echeqMassManageListUtils";
import { DETAIL_SCOPE_MODAL } from "pages/v2/echeqMassManagement/echeqMassManageUtils";
import { globalTypes } from "reducers/types/global";

export const types = {
    PRE_REQUEST: "echeqMassManagement/PRE_REQUEST",
    PRE_FAILURE: "echeqMassManagement/PRE_FAILURE",
    PRE_SUCCESS: "echeqMassManagement/PRE_SUCCESS",
    PREVIEW_REQUEST: "echeqMassManagement/PREVIEW_REQUEST",
    PREVIEW_FAILURE: "echeqMassManagement/PREVIEW_FAILURE",
    PREVIEW_SUCCESS: "echeqMassManagement/PREVIEW_SUCCESS",
    SEND_REQUEST: "echeqMassManagement/SEND_REQUEST",
    SEND_FAILURE: "echeqMassManagement/SEND_FAILURE",
    SEND_SUCCESS: "echeqMassManagement/SEND_SUCCESS",
    LIST_REQUEST: "echeqMassManagement/LIST_REQUEST",
    LIST_FAILURE: "echeqMassManagement/LIST_FAILURE",
    LIST_SUCCESS: "echeqMassManagement/LIST_SUCCESS",
    CLEAN_DATA: "echeqMassManagement/CLEAN_DATA",
    CLEAN_FORM_FLOW: "echeqMassManagement/CLEAN_FORM_FLOW",
    SET_TRANSACTION_DATA: "echeqMassManagement/SET_TRANSACTION_DATA",
    DETAIL_REQUEST: "echeqMassManagement/DETAIL_REQUEST",
    DETAIL_FAILURE: "echeqMassManagement/DETAIL_FAILURE",
    DETAIL_SUCCESS: "echeqMassManagement/DETAIL_SUCCESS",
    ITEM_RECEIPT_REQUEST: "echeqMassManagement/ITEM_RECEIPT_REQUEST",
    ITEM_RECEIPT_SUCCESS: "echeqMassManagement/ITEM_RECEIPT_SUCCESS",
    ITEM_RECEIPT_FAILURE: "echeqMassManagement/ITEM_RECEIPT_FAILURE",
    ITEM_RECEIPT_PDF_REQUEST: "echeqMassManagement/ITEM_RECEIPT_PDF_REQUEST",
    UPDATE_RECEIPT_CACHE_ENTRY: "echeqMassManagement/UPDATE_RECEIPT_CACHE_ENTRY",
    CLEAR_ITEM_RECEIPT: "echeqMassManagement/CLEAR_ITEM_RECEIPT",
    CLEAR_RECEIPT_CACHE: "echeqMassManagement/CLEAR_RECEIPT_CACHE",
    RESET_BATCH_DETAIL_FILTERS: "echeqMassManagement/RESET_BATCH_DETAIL_FILTERS",
    BATCH_DOWNLOAD_REQUEST: "echeqMassManagement/BATCH_DOWNLOAD_REQUEST",
    BATCH_DOWNLOAD_SUCCESS: "echeqMassManagement/BATCH_DOWNLOAD_SUCCESS",
    BATCH_DOWNLOAD_FAILURE: "echeqMassManagement/BATCH_DOWNLOAD_FAILURE",
    SET_TICKET_RETURN_TO_BATCH_LIST: "echeqMassManagement/SET_TICKET_RETURN_TO_BATCH_LIST",
};

const FORM_FLOW_INITIAL_STATE = {
    summary: null,
    formData: null,
    actions: [],
    transactionData: null,
    batchDetailList: [],
    batchDetailHeader: null,
    detailScope: DETAIL_SCOPE_MODAL,
    detailStatusFilter: "ALL",
    detailPageNumber: 1,
    detailTotalPages: 0,
    fetchingDetail: false,
    batchDetailItemReceipt: null,
    fetchingItemReceipt: false,
    fetchingPendingTicket: false,
    batchDetailReceiptCache: {},
    batchDetailIdBatch: null,
    fetchingPre: false,
    fetchingPreview: false,
    fetchingSend: false,
    fetchingBatchDownload: false,
};

export const INITIAL_STATE = {
    ...FORM_FLOW_INITIAL_STATE,
    ticketReturnToBatchList: false,
    listFilters: getDefaultListFilters(),
    listFiltersCustomized: false,
    batchList: [],
    totalPages: 0,
    pageNumber: 0,
    fetchingList: false,
};

export default (state = INITIAL_STATE, action = {}) => {
    const { summary, formData, actions } = action;

    switch (action.type) {
        case globalTypes.RESET_SELECTED_ELEMENTS:
            return { ...INITIAL_STATE };
        case globalTypes.CLEAN_UP:
            return INITIAL_STATE;
        case types.PRE_REQUEST:
            return {
                ...state,
                fetchingPre: true,
            };
        case types.PRE_FAILURE:
            return {
                ...state,
                fetchingPre: false,
                actions: FORM_FLOW_INITIAL_STATE.actions,
            };
        case types.PRE_SUCCESS:
            return {
                ...state,
                fetchingPre: false,
                actions,
            };
        case types.PREVIEW_REQUEST:
            return {
                ...state,
                fetchingPreview: true,
                formData,
            };
        case types.PREVIEW_FAILURE:
            return {
                ...state,
                fetchingPreview: false,
            };
        case types.PREVIEW_SUCCESS:
            return {
                ...state,
                fetchingPreview: false,
                summary,
                formData,
            };
        case types.SEND_REQUEST:
            return {
                ...state,
                fetchingSend: true,
            };
        case types.SEND_FAILURE:
            return {
                ...state,
                fetchingSend: false,
            };
        case types.SEND_SUCCESS:
            return {
                ...state,
                fetchingSend: false,
                ticketReturnToBatchList: true,
            };
        case types.LIST_REQUEST:
            return {
                ...state,
                listFilters: action.filters,
                fetchingList: true,
                ...(action.listFiltersCustomized !== undefined
                    ? { listFiltersCustomized: action.listFiltersCustomized }
                    : {}),
            };
        case types.LIST_FAILURE:
            return {
                ...state,
                fetchingList: false,
            };
        case types.LIST_SUCCESS: {
            const safeList = Array.isArray(action.list) ? action.list : [];
            const batchList =
                action.pageNumber <= 1 || action.isDesktop ? safeList : [...(state.batchList || []), ...safeList];
            return {
                ...state,
                batchList,
                pageNumber: action.pageNumber,
                totalPages: action.totalPages,
                fetchingList: false,
            };
        }
        case types.CLEAN_FORM_FLOW:
            return {
                ...state,
                ...FORM_FLOW_INITIAL_STATE,
                ticketReturnToBatchList: state.ticketReturnToBatchList,
            };
        case types.CLEAN_DATA:
            return {
                ...INITIAL_STATE,
            };
        case types.SET_TRANSACTION_DATA:
            return {
                ...state,
                transactionData: action.transactionData,
            };
        case types.DETAIL_REQUEST: {
            const isNewBatch = action.idBatch != null && action.idBatch !== state.batchDetailIdBatch;
            return {
                ...state,
                fetchingDetail: true,
                detailPageNumber: action.pageNumber,
                detailScope: action.detailScope ?? state.detailScope,
                detailStatusFilter: action.statusFilter ?? state.detailStatusFilter,
                ...(isNewBatch
                    ? {
                          batchDetailIdBatch: action.idBatch,
                          batchDetailReceiptCache: {},
                          batchDetailItemReceipt: null,
                          fetchingItemReceipt: false,
                          fetchingPendingTicket: false,
                      }
                    : {}),
                ...(action.pageNumber <= 1 ? { batchDetailList: [] } : {}),
            };
        }
        case types.DETAIL_FAILURE:
            return {
                ...state,
                fetchingDetail: false,
            };
        case types.DETAIL_SUCCESS: {
            const detailList =
                action.pageNumber <= 1 || action.isDesktop
                    ? action.detailList
                    : [...(state.batchDetailList || []), ...action.detailList];
            return {
                ...state,
                batchDetailList: detailList,
                batchDetailHeader: action.batchHeader ?? state.batchDetailHeader,
                detailScope: action.detailScope ?? state.detailScope,
                detailStatusFilter: action.statusFilter ?? state.detailStatusFilter,
                detailPageNumber: action.pageNumber,
                detailTotalPages: action.totalPages,
                fetchingDetail: false,
            };
        }
        case types.ITEM_RECEIPT_REQUEST: {
            if (action.item?.status === "PENDING") {
                return {
                    ...state,
                    fetchingPendingTicket: true,
                    fetchingItemReceipt: false,
                    batchDetailItemReceipt: null,
                };
            }

            const idTransaction = action.item?.idTransaction;
            const cachedReceipt = idTransaction
                ? getReceiptFromCacheEntry(state.batchDetailReceiptCache[idTransaction])
                : null;

            if (cachedReceipt) {
                return {
                    ...state,
                    fetchingItemReceipt: false,
                    fetchingPendingTicket: false,
                    batchDetailItemReceipt: cachedReceipt,
                };
            }

            return {
                ...state,
                fetchingItemReceipt: true,
                fetchingPendingTicket: false,
                batchDetailItemReceipt: null,
            };
        }
        case types.ITEM_RECEIPT_SUCCESS: {
            const { idTransaction, receipt, transaction } = action;
            const nextCache =
                idTransaction != null
                    ? {
                          ...state.batchDetailReceiptCache,
                          [idTransaction]: { receipt, transaction: transaction || null },
                      }
                    : state.batchDetailReceiptCache;

            return {
                ...state,
                fetchingItemReceipt: false,
                fetchingPendingTicket: false,
                batchDetailItemReceipt: action.receipt,
                batchDetailReceiptCache: nextCache,
            };
        }
        case types.ITEM_RECEIPT_FAILURE:
            return {
                ...state,
                fetchingItemReceipt: false,
                fetchingPendingTicket: false,
                batchDetailItemReceipt: null,
            };
        case types.UPDATE_RECEIPT_CACHE_ENTRY: {
            const { idTransaction, transaction } = action;
            if (idTransaction == null) {
                return state;
            }

            const existing = state.batchDetailReceiptCache[idTransaction];
            const previousReceipt = isStructuredReceiptCacheEntry(existing) ? existing.receipt : existing;

            return {
                ...state,
                batchDetailReceiptCache: {
                    ...state.batchDetailReceiptCache,
                    [idTransaction]: {
                        ...(previousReceipt ? { receipt: previousReceipt } : {}),
                        transaction,
                    },
                },
            };
        }
        case types.CLEAR_ITEM_RECEIPT:
            return {
                ...state,
                fetchingItemReceipt: false,
                fetchingPendingTicket: false,
                batchDetailItemReceipt: null,
            };
        case types.CLEAR_RECEIPT_CACHE:
            return {
                ...state,
                batchDetailReceiptCache: {},
                batchDetailIdBatch: null,
                fetchingItemReceipt: false,
                fetchingPendingTicket: false,
                batchDetailItemReceipt: null,
            };
        case types.RESET_BATCH_DETAIL_FILTERS:
            return {
                ...state,
                detailStatusFilter: FORM_FLOW_INITIAL_STATE.detailStatusFilter,
                detailPageNumber: FORM_FLOW_INITIAL_STATE.detailPageNumber,
            };
        case types.BATCH_DOWNLOAD_REQUEST:
            return {
                ...state,
                fetchingBatchDownload: true,
            };
        case types.BATCH_DOWNLOAD_SUCCESS:
        case types.BATCH_DOWNLOAD_FAILURE:
            return {
                ...state,
                fetchingBatchDownload: false,
            };
        case types.SET_TICKET_RETURN_TO_BATCH_LIST:
            return {
                ...state,
                ticketReturnToBatchList: Boolean(action.ticketReturnToBatchList),
            };
        default:
            return state;
    }
};

export const actions = {
    preRequest: () => ({
        type: types.PRE_REQUEST,
    }),
    previewRequest: (formData) => ({
        type: types.PREVIEW_REQUEST,
        formData,
    }),
    sendRequest: (summary, otp, setSubmitting) => ({
        type: types.SEND_REQUEST,
        summary,
        otp,
        setSubmitting,
    }),
    listRequest: (filters, isDesktop, listFiltersCustomized) => ({
        type: types.LIST_REQUEST,
        filters,
        isDesktop,
        ...(listFiltersCustomized !== undefined ? { listFiltersCustomized } : {}),
    }),
    cleanData: () => ({
        type: types.CLEAN_DATA,
    }),
    cleanFormFlow: () => ({
        type: types.CLEAN_FORM_FLOW,
    }),
    setTransactionData: (transactionData) => ({
        type: types.SET_TRANSACTION_DATA,
        transactionData,
    }),
    detailRequest: (idBatch, pageNumber, isDesktop, options = {}) => ({
        type: types.DETAIL_REQUEST,
        idBatch,
        pageNumber,
        isDesktop,
        detailScope: options.detailScope || DETAIL_SCOPE_MODAL,
        statusFilter: options.statusFilter,
    }),
    itemReceiptRequest: (item) => ({
        type: types.ITEM_RECEIPT_REQUEST,
        item,
    }),
    itemReceiptPdfRequest: (item, dispatch) => ({
        type: types.ITEM_RECEIPT_PDF_REQUEST,
        item,
        dispatch,
    }),
    clearItemReceipt: () => ({
        type: types.CLEAR_ITEM_RECEIPT,
    }),
    clearReceiptCache: () => ({
        type: types.CLEAR_RECEIPT_CACHE,
    }),
    resetBatchDetailFilters: () => ({
        type: types.RESET_BATCH_DETAIL_FILTERS,
    }),
    batchDownloadRequest: (idBatch) => ({
        type: types.BATCH_DOWNLOAD_REQUEST,
        idBatch,
    }),
    setTicketReturnToBatchList: (ticketReturnToBatchList) => ({
        type: types.SET_TICKET_RETURN_TO_BATCH_LIST,
        ticketReturnToBatchList,
    }),
};

export const selectors = {
    getSummary: ({ echeqMassManagement }) => echeqMassManagement.summary,
    getFormData: ({ echeqMassManagement }) => echeqMassManagement.formData,
    getActions: ({ echeqMassManagement }) => echeqMassManagement.actions,
    getFetchingPre: ({ echeqMassManagement }) => echeqMassManagement.fetchingPre,
    getFetchingPreview: ({ echeqMassManagement }) => echeqMassManagement.fetchingPreview,
    getFetchingSend: ({ echeqMassManagement }) => echeqMassManagement.fetchingSend,
    getTransactionData: ({ echeqMassManagement }) => echeqMassManagement.transactionData,
    getBatchDetailHeader: ({ echeqMassManagement }) => echeqMassManagement.batchDetailHeader,
    getBatchDetailList: ({ echeqMassManagement }) => echeqMassManagement.batchDetailList,
    getDetailScope: ({ echeqMassManagement }) => echeqMassManagement.detailScope,
    getDetailStatusFilter: ({ echeqMassManagement }) => echeqMassManagement.detailStatusFilter,
    getDetailPageNumber: ({ echeqMassManagement }) => echeqMassManagement.detailPageNumber,
    getDetailTotalPages: ({ echeqMassManagement }) => echeqMassManagement.detailTotalPages,
    getFetchingDetail: ({ echeqMassManagement }) => echeqMassManagement.fetchingDetail,
    getBatchDetailItemReceipt: ({ echeqMassManagement }) => echeqMassManagement.batchDetailItemReceipt,
    getFetchingItemReceipt: ({ echeqMassManagement }) => echeqMassManagement.fetchingItemReceipt,
    getFetchingPendingTicket: ({ echeqMassManagement }) => echeqMassManagement.fetchingPendingTicket,
    getBatchList: ({ echeqMassManagement }) => echeqMassManagement.batchList,
    getListFilters: ({ echeqMassManagement }) => echeqMassManagement.listFilters,
    getListFiltersCustomized: ({ echeqMassManagement }) => echeqMassManagement.listFiltersCustomized,
    getTotalPages: ({ echeqMassManagement }) => echeqMassManagement.totalPages,
    getPageNumber: ({ echeqMassManagement }) => echeqMassManagement.pageNumber,
    getFetchingList: ({ echeqMassManagement }) => echeqMassManagement.fetchingList,
    getFetchingBatchDownload: ({ echeqMassManagement }) => echeqMassManagement.fetchingBatchDownload,
    getTicketReturnToBatchList: ({ echeqMassManagement }) => echeqMassManagement.ticketReturnToBatchList,
};
